import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TargetingTypeFilterBody = _resolveComponent("TargetingTypeFilterBody");
  const _component_FilterItem = _resolveComponent("FilterItem");
  return _openBlock(), _createBlock(_component_FilterItem, {
    id: "targeting-types",
    class: "targeting-types-filter",
    ref: "targetingTypeFilterItem",
    icon: "TargetDartIcon",
    selectedCount: $props.targeting_types?.filterState?.selectedCount,
    onClearAll: $options.onClear,
    title: $options.getTargetingTypeTitle,
    selectedTitle: $options.getTargetingTypeSelectedTitle,
    onApply: $options.onApply,
    onHidden: $options.onHidden
  }, {
    body: _withCtx(() => [_createVNode(_component_TargetingTypeFilterBody, {
      title: $props.title,
      selected: $props.targeting_types?.filterState?.selected,
      isModified: $props.targeting_types.isModified,
      pendingChanges: $props.targeting_types.pendingChanges,
      isSearching: $props.targeting_types.isSearching,
      keyword: $props.targeting_types.keyword,
      list: $props.targeting_types.displayList,
      onClear: $options.onClear,
      onDiscard: $options.onDiscard,
      onRestoreSearch: $options.onRestoreSearch,
      onSelect: $options.onSelect,
      onSelectOnly: $options.onSelectOnly,
      onDeselect: $options.onDeselect,
      onApply: $options.onApply,
      onSearch: $options.onSearch,
      onHidden: $options.onHidden,
      onCloseDropdown: _ctx.$refs?.targetingTypeFilterItem?.closeDropdown
    }, null, 8, ["title", "selected", "isModified", "pendingChanges", "isSearching", "keyword", "list", "onClear", "onDiscard", "onRestoreSearch", "onSelect", "onSelectOnly", "onDeselect", "onApply", "onSearch", "onHidden", "onCloseDropdown"])]),
    _: 1
  }, 8, ["selectedCount", "onClearAll", "title", "selectedTitle", "onApply", "onHidden"]);
}